(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["puracy-home-featured-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-puracy-featured-tabs]');

    sections.forEach((root) => {
      if (root.dataset.puracyFeaturedTabsReady === 'true') return;
      root.dataset.puracyFeaturedTabsReady = 'true';

      const triggers = Array.from(root.querySelectorAll('[data-tab-trigger]'));
      const panels = Array.from(root.querySelectorAll('[data-tab-panel]'));

      const activate = (key) => {
        let activePanel = null;

        triggers.forEach((trigger) => {
          const active = trigger.getAttribute('data-tab-trigger') === key;
          trigger.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const active = panel.getAttribute('data-tab-panel') === key;
          panel.hidden = !active;
          if (active) activePanel = panel;
        });

        const activeRail = activePanel?.querySelector('[data-tab-rail]');
        if (activeRail) {
          activeRail.scrollTo({ left: 0, behavior: 'auto' });
        }
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => activate(trigger.getAttribute('data-tab-trigger')));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["puracy-home-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-puracy-testimonials]');

    sections.forEach((root) => {
      if (root.dataset.puracyTestimonialsReady === 'true') return;
      root.dataset.puracyTestimonialsReady = 'true';

      const track = root.querySelector('[data-testimonial-track]');
      const prev = root.querySelector('[data-testimonial-prev]');
      const next = root.querySelector('[data-testimonial-next]');
      if (!track || !prev || !next) return;

      const getStep = () => {
        const first = track.querySelector('.puracy-home-testimonials__card');
        if (!first) return track.clientWidth;
        const styles = window.getComputedStyle(track);
        return first.getBoundingClientRect().width + parseFloat(styles.columnGap || styles.gap || 0);
      };

      prev.addEventListener('click', () => {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
